import moment from 'moment-timezone';

export default function osloMoment(...args) {
  return moment.tz.apply(null, args.concat('Europe/Oslo'));
}
